(() => {
  'use strict';
  const aomTrack = (n, p) => window.aomTrack?.(n, p);
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const container = $('#aom-img-custom-scrollableContainer');
  if (!container) return;

  const leftBtn = $('#aom_custom_img_btn_left');
  const rightBtn = $('#aom_custom_img_btn_right');

  let cards = $$('.aom-custom-review-img-card', container);
  const mqMobile = window.matchMedia('(max-width: 768px)');

  // If no cards, just disable buttons (they're hidden on mobile anyway)
  if (cards.length === 0) {
    [leftBtn, rightBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = true;
      btn.classList.add('disabled');
    });
    return;
  }

  // Compute scroll step: first card width + CSS gap
  function computeScrollStep() {
    const style = getComputedStyle(container);
    const gap = parseFloat(style.columnGap || style.gap || '0');
    const w = cards[0]?.getBoundingClientRect().width || container.clientWidth;
    return Math.ceil(w + gap);
  }
  let scrollStep = computeScrollStep();

  // Recompute on layout/size changes
  new ResizeObserver(() => {
    scrollStep = computeScrollStep();
    updateNavButtons();
  }).observe(container);

  // Detect whether we actually overflow horizontally
  function hasHorizontalOverflow() {
    return container.scrollWidth > Math.ceil(container.clientWidth + 1) && cards.length > 1;
  }

  // Only toggle disabled state; keep arrows visible on desktop
  function setBtnState(btn, enabled) {
    if (!btn) return;
    btn.disabled = !enabled;
    btn.classList.toggle('disabled', !enabled);
    // Visibility: desktop always visible; mobile hidden by CSS media query
    btn.style.display = mqMobile.matches ? 'none' : 'flex';
  }

  function updateNavButtons() {
    const scrollable = hasHorizontalOverflow();

    if (!scrollable) {
      setBtnState(leftBtn, false);
      setBtnState(rightBtn, false);
      return;
    }

    const atStart = container.scrollLeft <= 1;
    const maxLeft = container.scrollWidth - container.clientWidth - 1;
    const atEnd = container.scrollLeft >= maxLeft;

    setBtnState(leftBtn, !atStart);
    setBtnState(rightBtn, !atEnd);
  }

  // Throttle helper
  function throttle(fn, wait = 100) {
    let last = 0;
    return (...args) => {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn.apply(null, args);
      }
    };
  }

  // Button interactions
  leftBtn?.addEventListener('click', () => {
    container.scrollBy({ left: -scrollStep, behavior: 'smooth' });
  });
  rightBtn?.addEventListener('click', () => {
    container.scrollBy({ left: scrollStep, behavior: 'smooth' });
  });

  // Keyboard: focus a card then use arrows
  container.addEventListener('keydown', (e) => {
    const card = e.target.closest('.aom-custom-review-img-card');
    if (!card) return;
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      rightBtn?.click();
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      leftBtn?.click();
    }
  });

  // Make cards focusable
  cards.forEach((c) => {
    if (!c.hasAttribute('tabindex')) c.tabIndex = 0;
  });

  // Update on scroll/resize/media query and on load (covers late asset layout shifts)
  container.addEventListener('scroll', throttle(updateNavButtons, 100), { passive: true });
  mqMobile.addEventListener?.('change', updateNavButtons);
  window.addEventListener('load', updateNavButtons);
  updateNavButtons();

  // Optional: IO-based lazy-loading if using <img data-src="...">
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const img = entry.target.querySelector('img');
        if (img && img.dataset && img.dataset.src && !img.src) {
          img.src = img.dataset.src;
        }
        io.unobserve(entry.target);
      });
    },
    { root: container, threshold: 0.25, rootMargin: '0px 50px' }
  );

  cards.forEach((card) => io.observe(card));

  // ─── Story Photo Modal ────────────────────────────────────────────────────────────

  const photoData = cards.map((card) => {
    const img = card.querySelector('img');
    return {
      // data-full is the uncropped original; src is the 250x400 card crop.
      src:   img?.getAttribute('data-full') || img?.getAttribute('src') || img?.getAttribute('data-src') || '',
      alt:   img?.alt || '',
      title: card.dataset.title || img?.alt || '',
    };
  });

  const pcModal   = document.getElementById('ao-pc-modal');
  if (!pcModal) return;

  const pcImg     = pcModal.querySelector('.ao-pc-modal-img');
  const pcProgWrap = pcModal.querySelector('.ao-pc-progress-bars');
  const pcCaption = pcModal.querySelector('.ao-pc-caption');
  const pcCloseBtn = pcModal.querySelector('.ao-pc-close');
  const pcTapPrev = pcModal.querySelector('.ao-pc-tap-prev');
  const pcTapNext = pcModal.querySelector('.ao-pc-tap-next');

  const SLIDE_MS = 3000; // ms per photo
  let pcIdx      = 0;
  let pcRafId    = null;
  let pcStart    = null; // timestamp when current slide started

  function pcBuildBars() {
    pcProgWrap.innerHTML = '';
    photoData.forEach(() => {
      const bar  = document.createElement('div');
      bar.className = 'ao-pc-progress-bar';
      const fill = document.createElement('div');
      fill.className = 'ao-pc-progress-bar-fill';
      bar.appendChild(fill);
      pcProgWrap.appendChild(bar);
    });
  }

  function pcSetBars(idx, pct) {
    pcProgWrap.querySelectorAll('.ao-pc-progress-bar-fill').forEach((f, i) => {
      f.style.width = i < idx ? '100%' : i === idx ? `${Math.max(0, Math.min(1, pct)) * 100}%` : '0%';
    });
  }

  // RAF loop — drives the current bar from 0→100% over SLIDE_MS, then auto-advances
  function pcRaf(ts) {
    if (pcStart === null) pcStart = ts;
    const pct = Math.min((ts - pcStart) / SLIDE_MS, 1);
    pcSetBars(pcIdx, pct);
    if (pct < 1) {
      pcRafId = requestAnimationFrame(pcRaf);
    } else if (pcIdx < photoData.length - 1) {
      pcGoTo(pcIdx + 1);
    } else {
      pcClose();
    }
  }

  function pcStartTimer() {
    cancelAnimationFrame(pcRafId);
    pcStart = null;
    pcRafId = requestAnimationFrame(pcRaf);
  }

  function pcGoTo(idx) {
    if (idx < 0 || idx >= photoData.length) return;
    pcIdx = idx;
    const data = photoData[idx];
    pcImg.src           = data.src;
    pcImg.alt           = data.alt;
    pcCaption.textContent = data.title;
    pcSetBars(idx, 0);
    // Hide prev tap zone on first photo; always show next (on last photo it closes)
    pcTapPrev.style.display = idx === 0 ? 'none' : 'block';
    pcTapNext.style.display = 'block';
    pcStartTimer();
  }

  function pcOpen(idx) {
    aomTrack('aom_photo_open', {
      ui_element:  'photo_carousel',
      action_type: 'modal_open',
      photo_index: idx,
      photo_title: photoData[idx]?.title || '',
    });
    pcBuildBars();
    document.body.style.overflow = 'hidden';
    pcModal.showModal();
    pcGoTo(idx);
  }

  function pcClose() {
    cancelAnimationFrame(pcRafId);
    pcRafId = null;
    pcStart = null;
    pcModal.close();
    document.body.style.overflow = '';
  }

  // Escape key via dialog 'cancel'
  pcModal.addEventListener('cancel', (e) => { e.preventDefault(); pcClose(); });

  pcCloseBtn.addEventListener('click', pcClose);

  pcTapPrev.addEventListener('click', () => {
    aomTrack('aom_photo_navigate', {
      ui_element:  'photo_carousel',
      action_type: 'navigate',
      direction:   'prev',
      photo_index: pcIdx - 1,
    });
    pcGoTo(pcIdx - 1);
  });
  pcTapNext.addEventListener('click', () => {
    if (pcIdx === photoData.length - 1) {
      pcClose();
    } else {
      aomTrack('aom_photo_navigate', {
        ui_element:  'photo_carousel',
        action_type: 'navigate',
        direction:   'next',
        photo_index: pcIdx + 1,
      });
      pcGoTo(pcIdx + 1);
    }
  });

  // Keyboard
  pcModal.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  pcGoTo(pcIdx - 1);
    if (e.key === 'ArrowRight') {
      if (pcIdx === photoData.length - 1) pcClose();
      else pcGoTo(pcIdx + 1);
    }
    if (e.key === 'Escape') { e.preventDefault(); pcClose(); }
  });

  // Tap backdrop to close
  pcModal.addEventListener('click', (e) => { if (e.target === pcModal) pcClose(); });

  // Open on card click
  cards.forEach((card) => {
    card.addEventListener('click', () => {
      const idx = parseInt(card.dataset.index ?? '-1', 10);
      if (idx >= 0) pcOpen(idx);
    });
  });
})();
